export const MIN_HEIGHT = 150;
export const BORDER_HEIGHT = 1;
export const HANDLE_HEIGHT = 4;
export const HEADER_HEIGHT = 36 + BORDER_HEIGHT;
